<template>
  <div class="detailMain">
    <div class="returnBtn" @click="goBack()">
      <i class="el-icon-back"></i>
    </div>
    <el-breadcrumb class="crumbs" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item v-for="(item,index)  in routeList" :key="index"
        :to="{ name: item.name,query:{id:item.query.id,flag:item.query.flag,name:item.query.name} }">
        {{item.name}}
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-card shadow="never">
      <div class="cardTop">
        <h1>{{ detailData.name }}</h1>
        <h2>网关协议</h2>
        <el-dropdown v-if="(user_name == 'suadmin' && detailData.type == 1) || (user_name != 'suadmin' && detailData.type != 1)" @command="handleCommand">
          <span class="el-dropdown-link">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="edit">编辑</el-dropdown-item>
            <el-dropdown-item command="del">删除</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="cardBottom">
        <el-tabs tab-position="left" style="height: 520px;" @tab-click="tabClick">
          <el-tab-pane label="详情">
            <h1>协议详情</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>编号</label> <br />
                  <span>{{ detailData.code }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>名称</label> <br />
                  <span>{{ detailData.name }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>心跳包的值（hex）</label> <br />
                  <span>{{ detailData.heartbeat }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>通信类型</label> <br />
                  <span>{{ detailData.commuType==1?"TCP":detailData.commuType==2?"UDP":"其他" }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>协议脚本</label> <br />
                  <p v-if="detailData.analysisTemplateType==2">
                    <el-button type="text" @click="showAnalysisScript = true">查看脚本</el-button>
                  </p>
                  <p v-if="detailData.analysisTemplateType!=2">无</p>
                  <!--<el-button-->
                  <!--type="text"-->
                  <!--v-if="detailData.analysisScriptAttachmentId"-->
                  <!--@click="download(detailData.analysisScriptAttachmentId)"-->
                  <!--&gt;下载</el-button>-->
                  <!--<p v-if="detailData.analysisScriptAttachmentId == null || detailData.analysisScriptAttachmentId==''">无</p>-->
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>通信端口</label> <br />
                  <span>{{  detailData.commuPort != null ? detailData.commuPort :"其他" }}</span>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>协议说明文档</label> <br />
                  <span>{{detailData.attachmentName}}</span>
                  <el-button type="text" v-if="detailData.attachmentId" @click="download(detailData.attachmentId)">下载
                  </el-button>
                  <p v-if="detailData.attachmentId == null || detailData.attachmentId==''">无</p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="grid-content bg-purple">
                  <label>协议使用说明</label> <br />
                  <span>{{detailData.manual != null ? detailData.manual :"---"}}</span>
                </div>
              </el-col>
            </el-row>
            <h1 style="margin-top:30px">系统信息</h1>
            <el-row class="formRow">
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建人</label> <br />
                  <span> {{detailData.creator != null ? detailData.creator : "---"
                  }}</span>
                </div>
              </el-col>
              <el-col :span="12">
                <div class="grid-content bg-purple">
                  <label>创建时间</label> <br />
                  <span>{{
                    detailData.createDate != null
                      ? changeDate(detailData.createDate)
                      : "---"
                  }}</span>
                </div>
              </el-col>
            </el-row>
          </el-tab-pane>
          <el-tab-pane label="适配品牌/型号">
            <h1>适配品牌/型号</h1>
            <el-table :data="brandModelData" border>
              <el-table-column prop="brand" label="品牌"> </el-table-column>
              <el-table-column prop="model" label="型号"> </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="已连接网关">
            <h1>已连接网关</h1>
            <el-table :data="subDeviceData" height='450px'>
              <el-table-column prop="code" label="网关编号">
                <template slot-scope="scope">
                  <el-button class="tableButton" @click="detailBtn(scope.row.id)">
                    {{ scope.row.code }}</el-button>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="网关名称"> </el-table-column>
              <el-table-column prop="onlineStatus" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.onlineStatus==0"> <i class="redDot"></i>离线</span>
                  <span v-else-if="scope.row.onlineStatus==1"> <i class="greenDot"></i>在线</span>
                  <span v-else>---</span>
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[10, 20, 50, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination> -->
          </el-tab-pane>

        </el-tabs>
      </div>
    </el-card>
    <el-dialog title="协议脚本" :visible.sync="showAnalysisScript" :close-on-click-modal="false"
      :close-on-press-escape="false" :show-close="false">
      <div style="height:300px;">
        <el-button style="position: absolute;margin-top: 5px;z-index: 99;right: 30px;" @click="copyText">复制</el-button>
        <el-input id="analysisScript" type="textarea" :readonly="true" resize="none"
          :autosize="{ minRows: 2, maxRows: 14}" placeholder="脚本内容" v-model="analysisScript">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showAnalysisScript = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from "dayjs";
  export default {
    data() {
      return {
        user_name: this.$cookies.get("user_name"),
        routeList: this.$route.meta.routeList,
        ids: this.$route.query.id,
        showAnalysisScript: false, //脚本模态框
        analysisScript: '', //脚本内容
        detailData: {}, //详情数据
        brandModelData: [], //品牌型号
        subDeviceData: [], //已连接网关
      };
    },
    created() {},
    methods: {

      //格式化时间
      changeDate(time) {
        return dayjs(new Date(time)).format("YYYY-MM-DD HH:mm:ss");
      },
      //获取详情数据
      getPlatformMduProtocol() {
        API.platformMduProtocol(this.ids).then(res => {
          if (res.code == 1) {
            this.detailData = res.data.mduProtocol
            if (res.data.mduProtocol.analysisTemplateType == 2) {
              var reg = new RegExp('/r/n', "g")
              var text = res.data.mduProtocol.analysisScript.replace(reg, '\n');
              this.analysisScript = text;
            }
          }
        })
      },
      //选择对应的tab时触发事件
      tabClick(val) {
        let _API = API
        let _this = this
        if (val.label == "适配品牌/型号") {
          //根据协议获取品牌型号
          _API.platformMduProtocolBrandModel(_this.ids).then(res => {
            if (res.code == 1) {
              _this.brandModelData = res.data.brandAndModel
            }
          });
        }
        if (val.label == "已连接网关") {
          //根据协议获取所连网关
          _API.platformMduProtocolModule(_this.ids).then(res => {
            if (res.code == 1) {
              _this.subDeviceData = res.data.moduleList
            }
          });
        }
      },
      //操作下拉
      handleCommand(para) {
        if (para == "edit") {
          //编辑
          this.$router.push({
            path: "/device/protocolAdd",
            query: {
              id: this.ids,
              flag: 'edit'
            }
          });
        } else if (para == "del") {
          //删除
          let para = {
            ids: this.ids
          }
          this.$confirm('此操作将永久删除数据, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            API.delPlatformMduProtocol(para).then(res => {
              if (res.code == 1) {
                this.$message.success('删除成功');
                this.$router.push({
                  path: "/device/protocolLibraryManagement",
                });
              } else {
                var falseList = res.data;
                var errMsgStr;
                falseList.forEach(errMsg=>{
                  errMsgStr = errMsg.substring(errMsg.indexOf('删除失败'))
                  return;
                })
                this.$message.error(errMsgStr);
              }
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        }
      },
      //监控分页
      // handleSizeChange(val) {
      //   console.log(`每页 ${val} 条`);
      // },
      // handleCurrentChange(val) {
      //   console.log(`当前页: ${val}`);
      // },
      detailBtn(id) {
        this.$router.push({
          path: "/device/moduleDetail",
          query: {
            id: id
          }
        });
      },
      //下载功能
      download(id) {
        let token = this.$cookies.get('access_token');
        let url = id + "&access_token=" + (token ? token : '');
        window.location = API.download(url)
      },
      //复制脚本
      copyText() {
        let text = document.querySelector('#analysisScript');
        text.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.info('复制成功');
      }
    },
    mounted() {
      this.getPlatformMduProtocol()
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/moduleProtocolDetails.vue